import type { IframeState } from '../hooks/useIframeState';
import type { IframeScenario } from '../settings/iframes-mapping';

export interface IframeInfo {
    isPreloadingEnabled?: boolean;
    isHeuristicForPreloadingMet?: boolean;
    isCachingEnabled?: boolean;
    markedForEviction?: boolean;
    evictedFromCache?: boolean;
    currentState?: IframeState;
    isRendered?: boolean;
    nativeHostProcessId?: number;
    iframesCountPerProcess?: number;
}

const iframeInfoCache = new Map<IframeScenario, IframeInfo>();

// IMPORTANT: This currently tracks the total memory for all iframes matching the scenario
// We will eventually change it to track per-iframe using query parameters with unique IDs.
export function getIframeInfo(scenario: IframeScenario): IframeInfo | null {
    const cachedScenarioInfo = iframeInfoCache.get(scenario);
    if (cachedScenarioInfo) {
        return cachedScenarioInfo;
    }

    return null;
}

export function setIframeInfo(
    scenario: IframeScenario,
    key: keyof IframeInfo,
    value: boolean | IframeState | number
): void {
    const existingInfo = iframeInfoCache.get(scenario) || {
        isPreloadingEnabled: false,
        isCachingEnabled: false,
        markedForEviction: false,
        evictedFromCache: false,
    };

    iframeInfoCache.set(scenario, {
        ...existingInfo,
        [key]: value,
    });
}
